import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Heart, Plane, ChevronRight } from "lucide-react";
import { airports } from "@/data/airports";
import { SavedAirport } from "@/hooks/useSavedAirports";

interface SavedAirportsListProps {
  savedAirports: SavedAirport[];
  onSelect: (airport: string, terminal: string) => void;
}

export const SavedAirportsList = ({ savedAirports, onSelect }: SavedAirportsListProps) => {
  const navigate = useNavigate();

  if (savedAirports.length === 0) return null;

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 px-1">
        <Heart className="h-4 w-4 text-destructive fill-destructive" />
        <h2 className="text-sm font-semibold text-foreground">Your Airports</h2>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
        {savedAirports.map((saved) => {
          const airport = airports.find((a) => a.code === saved.airport_code);
          const cityName = airport?.city.split(",")[0] || "";

          return (
            <Card
              key={saved.id}
              className="flex-shrink-0 p-3 cursor-pointer hover:border-primary/40 transition-colors min-w-[140px]"
              onClick={() => onSelect(saved.airport_code, "A")}
            >
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="font-bold text-foreground">{saved.airport_code}</p>
                  <p className="text-xs text-muted-foreground truncate max-w-[100px]">{cityName}</p>
                </div>
                <ChevronRight className="h-4 w-4 text-muted-foreground flex-shrink-0" />
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
